// tokenUtils.ts
import { getApiBaseUrl } from "../utils/apiBaseUrl";

export const refreshToken = async (): Promise<string | null> => {
  try {
    const storedRefresh = localStorage.getItem('refreshToken');
    if (!storedRefresh) {
      console.warn('No refresh token in storage');
      return null;
    }
    const baseUrl = getApiBaseUrl();
    const response = await fetch(
      `${baseUrl}/api/Account/GetRefreshTokenAsync`,
      {
        method: 'POST',                                
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ refreshToken: storedRefresh }),
      }
    );

    if (!response.ok) {
      throw new Error(`Refresh failed: ${response.status}`);
    }
    const data = await response.json() as { token: string; refreshToken?: string; };

    localStorage.setItem('token', data.token);
    if (data.refreshToken) {
      localStorage.setItem('refreshToken', data.refreshToken);
    }

    return data.token;
  } catch (err) {
    console.error('Error refreshing token:', err);
    return null;
  }
};
